import { Plus, X } from 'lucide-react'

// Wraps a list item with a hover-revealed × delete button; pair with
// `<AddItemButton>` at the end of the list to insert new items.
//
// The wrapper is positioned `relative` and the button absolutely so the
// host content keeps the same layout it would have at runtime — the
// button just floats over the top-right corner during edit time.

export function InlineListItem({
  children,
  onRemove,
  removeLabel = 'Remove item',
  className,
  style,
}: {
  children: React.ReactNode
  onRemove?: () => void
  removeLabel?: string
  className?: string
  style?: React.CSSProperties
}) {
  return (
    <div className={`pg-list-item ${className ?? ''}`} style={style}>
      {children}
      {onRemove && (
        <button
          type="button"
          className="pg-item-remove"
          aria-label={removeLabel}
          title={removeLabel}
          tabIndex={-1}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            onRemove()
          }}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <X size={13} />
        </button>
      )}
    </div>
  )
}

export function AddItemButton({
  label = 'Add item',
  onClick,
  style,
}: {
  label?: string
  onClick: () => void
  style?: React.CSSProperties
}) {
  return (
    <button
      type="button"
      className="pg-add-item"
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        onClick()
      }}
      onMouseDown={(e) => e.stopPropagation()}
      style={style}
    >
      <Plus size={13} />
      <span>{label}</span>
    </button>
  )
}
